import axiosInstance from './AxiosInstance';

/**
 * Obtiene todos los países disponibles
 * GET /selectores/paises
 */
export function getCountries() {
    return axiosInstance.get('/selectores/paises');
}

/**
 * Obtiene todas las ciudades disponibles con su país asociado
 * GET /selectores/ciudades
 */
export function getAllCities() {
    return axiosInstance.get('/selectores/ciudades');
}

/**
 * Obtiene las ciudades de un país específico
 * GET /selectores/ciudades/{paisId}
 * @param {string} paisId - ID del país (UUID)
 */
export function getCitiesByCountry(paisId) {
    return axiosInstance.get(`/selectores/ciudades/${paisId}`);
}

/**
 * Obtiene todos los selectores necesarios para crear/editar vacantes
 * GET /selectores/all
 * Retorna: categorias, modalidadesTrabajo, tiposTrabajo, tiposContrato, tiemposExperiencia, paises, ciudades
 */
export function getAllSelectors() {
    return axiosInstance.get('/selectores/all');
}

